import { Checkbox } from '@wix/design-system';
import React from 'react';
import { FiltersMap } from '@wix/bex-core';
import { observer } from 'mobx-react-lite';
import { PickerContentState } from '../../state';

export interface SelectAllCheckboxProps<T, F extends FiltersMap> {
  state: PickerContentState<T, F>;
}

function _SelectAllCheckbox<T, F extends FiltersMap>(
  props: SelectAllCheckboxProps<T, F>,
) {
  const { state } = props;
  const {
    toggleIsSelectAll,
    picker: {
      collection: {
        result: { isEmptyAndNotFetching },
        query: { hasActiveFilters },
        bulkSelect: {
          selectedCountOrTotal,
          select: { isNotEmptyEnabledItems: hasEnabledCheckedItems },
          isSelectAll,
          hasUnchecked,
          collection: {
            result: { total },
          },
        },
        translate: t,
      },
    },
  } = state;
  return (
    <Checkbox
      dataHook="picker-select-all-checkbox"
      checked={isSelectAll}
      disabled={hasActiveFilters || isEmptyAndNotFetching}
      onChange={toggleIsSelectAll}
      indeterminate={hasEnabledCheckedItems && (!isSelectAll || hasUnchecked)}
    >
      {hasEnabledCheckedItems ? (
        <>
          {t('cairo.deselectAll')}
          {!hasActiveFilters && <> ({selectedCountOrTotal})</>}
        </>
      ) : (
        <>
          {t('cairo.selectAll')}
          {!hasActiveFilters && <> ({total})</>}
        </>
      )}
    </Checkbox>
  );
}

export const SelectAllCheckbox = observer(_SelectAllCheckbox);
